var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 0.364258C12.3097 0.364258 14.8281 2.892 14.8281 6.01017C14.8281 9.12834 12.3097 11.6561 9.20312 11.6561C6.09651 11.6561 3.57812 9.12834 3.57812 6.01017C3.57812 2.892 6.09651 0.364258 9.20312 0.364258ZM15.6467 12.1438L13.1396 11.5147C10.5056 13.4163 7.31284 12.9919 5.26668 11.5147L2.75958 12.1438C1.25714 12.5208 0.203125 13.8757 0.203125 15.4302V16.7374C0.203125 17.6729 0.958633 18.4312 1.89062 18.4312H16.5156C17.4476 18.4312 18.2031 17.6729 18.2031 16.7374V15.4302C18.2031 13.8757 17.1491 12.5208 15.6467 12.1438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.d0db0c290e3c12fa13ba6cf6b2204d2a.svg";
export { ForwardRef as ReactComponent };